var Density;
(function (Density) {
    Density["COMPACT"] = "compact";
    Density["CONFORTABLE"] = "confortable";
    Density["DEFAULT"] = "default";
    Density["DENSE"] = "dense";
    Density["REGULAR"] = "regular";
    Density["TOUCH"] = "touch";
})(Density || (Density = {}));
export default Density;
//# sourceMappingURL=density.js.map